/**
 * Souk L7wayej Clothes Game Module Entry Point
 */
import SoukClothesGame from './SoukClothesGame';
import config from './config.json';

export { config };
export default SoukClothesGame;
